import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Applies buttery smooth scroll via CSS scroll-behavior on the homepage.
 * (Lenis was pulled — it prevented Framer Motion `useScroll` from reading updates.)
 * Respects prefers-reduced-motion.
 */
export default function SmoothScroll() {
  const location = useLocation();

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) {
      document.documentElement.style.scrollBehavior = "";
      return () => {};
    }
    document.documentElement.style.scrollBehavior = "smooth";
    return () => {
      document.documentElement.style.scrollBehavior = "";
    };
  }, [location.pathname]);

  return null;
}
